import { render, staticRenderFns } from "./SystemConfigOss.vue?vue&type=template&id=f56b0214&"
import script from "./SystemConfigOss.vue?vue&type=script&lang=js&"
export * from "./SystemConfigOss.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigOss.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports